const mixin = {
  computed: {
    emptyCart() {
      let { cart } = this.cartmes;
      return !cart || !Object.keys(cart).length
    },
  },
  methods: {
    computed_special_attrs(cart_mes) {
      //total,带特殊属性的所有商品总数
      //[19212]：带特殊属性的同一个商品但不同变种的总数
      //has_odd:false 购物车中带特殊属性的同一个商品中是否有奇数的
      let special_pro_num = {
        total: 0,
        has_odd: false,
      }
      let { cart } = cart_mes
      if (!cart) return special_pro_num
      let products = Object.values(cart)
      let special_attrs = this.$store.state.special_attrs
      if (!products || !products.length || !special_attrs || !Object.keys(special_attrs).length) return special_pro_num
      //special_attrs 有值
      let Obj_key = Object.keys(special_attrs)
      //special_attrs中需要特殊处理的数组有长度,并记录下有长度的那个name
      let special_name = Obj_key.find((item) => {
        return special_attrs[item].length
      })
      if (!special_name) return special_pro_num
      //至此确认购物车有数据，store中有需要处理的特殊字段
      products.forEach((item) => {
        let { product_id, variant, quantity } = item
        if (!variant) return special_pro_num
        let { attrs } = variant
        if (!attrs) return special_pro_num
        let onOff = attrs.some((subItem) => {
          return subItem.name.toLowerCase() == special_name
        })
        if (onOff) {
          special_pro_num.total += quantity
          special_pro_num[product_id] = special_pro_num[product_id] ? special_pro_num[product_id] + quantity : quantity
        }
      })
      for (const key in special_pro_num) {
        if (!isNaN(key) && special_pro_num[key] % 2) {
          special_pro_num.has_odd = true
        }
      }
      return special_pro_num
    },
  },
}
export default mixin
